var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwindcss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16c-7.1 0-11.6 3.5-13.5 10.5 2.7-3.5 5.8-4.8 9.3-3.9 2 .5 3.4 2 5 3.6 2.6 2.7 5.6 5.8 12.7 5.8 7.1 0 11.6-3.5 13.5-10.5-2.7 3.5-5.8 4.8-9.3 3.9-2-.5-3.4-2-5-3.6C42.1 19.1 39.1 16 32 16zM18.5 32c-7.1 0-11.6 3.5-13.5 10.5 2.7-3.5 5.8-4.8 9.3-3.9 2 .5 3.4 2 5 3.6 2.6 2.7 5.6 5.8 12.7 5.8 7.1 0 11.6-3.5 13.5-10.5-2.7 3.5-5.8 4.8-9.3 3.9-2-.5-3.4-2-5-3.6C28.6 35.1 25.6 32 18.5 32z",
    fill: "#38BDF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/tailwindcss.d3ecd578bb62b15472fe89bf8bac0984.svg";
export { ForwardRef as ReactComponent };